import * as yup from 'yup'

export const validateCreateProductPremiumCharacteristics = yup.object().shape({
    html_description: yup
    .string()
    .required('Campo requerido.')
    .min(3, 'LA DESCRIPCIÓN debe tener más de 2 caracteres'),
})